import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancelTokens = {
  evaluationGridTemplate: null,
  addField: null,
  deleteField: null,
  deleteTemplate: null,
};

class EvaluationGridTemplateService {
  getEvaluationGridTemplates() {
    if (cancelTokens.evaluationGridTemplate) cancelTokens.evaluationGridTemplate.cancel('Multiple requests.');
    cancelTokens.evaluationGridTemplate = CancelToken.source();

    return ApiService.get(`${Config.api.document.url}api/v1/evaluation-grid-templates`, {
      cancelToken: cancelTokens.evaluationGridTemplate.token,
    }).then((response) => response.data);
  }

  addField(templateId, fieldData) {
    if (cancelTokens.addField) cancelTokens.addField.cancel('Multiple requests.');
    cancelTokens.addField = CancelToken.source();

    return ApiService.post(
      `${Config.api.document.url}api/v1/evaluation-grid-templates/${templateId}/fields`,
      fieldData,
      {
        cancelToken: cancelTokens.addField.token,
      },
    )
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  deleteField(templateId, fieldId) {
    if (cancelTokens.deleteField) cancelTokens.deleteField.cancel('Multiple requests.');
    cancelTokens.deleteField = CancelToken.source();

    return ApiService.delete(
      `${Config.api.document.url}api/v1/evaluation-grid-templates/${templateId}/fields/${fieldId}`,
      {
        cancelToken: cancelTokens.deleteField.token,
      },
    )
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }
  editField(templateId, fieldId, fieldData) {
    if (cancelTokens.editField) cancelTokens.editField.cancel('Multiple requests.');
    cancelTokens.editField = CancelToken.source();

    return ApiService.put(
      `${Config.api.document.url}api/v1/evaluation-grid-templates/${templateId}/fields/${fieldId}`,
      fieldData,
      {
        cancelToken: cancelTokens.editField.token,
      },
    )
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  addTemplate(templateData) {
    if (cancelTokens.addTemplate) cancelTokens.addTemplate.cancel('Multiple requests.');
    cancelTokens.addTemplate = CancelToken.source();

    return ApiService.post(`${Config.api.document.url}api/v1/evaluation-grid-templates`, templateData, {
      cancelToken: cancelTokens.addTemplate.token,
    })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  deleteTemplate(templateId) {
    if (cancelTokens.deleteTemplate) cancelTokens.deleteTemplate.cancel('Multiple requests.');
    cancelTokens.deleteTemplate = CancelToken.source();

    return ApiService.delete(`${Config.api.document.url}api/v1/evaluation-grid-templates/${templateId}`, {
      cancelToken: cancelTokens.deleteTemplate.token,
    })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }
  editTemplate(templateId, templateData) {
    if (cancelTokens.editTemplate) cancelTokens.editTemplate.cancel('Multiple requests.');
    cancelTokens.editTemplate = CancelToken.source();

    return ApiService.put(`${Config.api.document.url}api/v1/evaluation-grid-templates/${templateId}`, templateData, {
      cancelToken: cancelTokens.editTemplate.token,
    })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }
}

export const evaluationGridTemplateService = new EvaluationGridTemplateService();
